import React from "react";
import { connect } from "react-redux";
import {
  Alert,
  Layout,
  Breadcrumb,
  Card,
  Form,
  Row,
  Col,
  Input,
  Upload,
  Button,
  Icon,
} from "antd";


import Footer from "../../components/Footer/Footer";
import classes from "./SettingsTheme.css";

import isAuthenticated from "../../utils/isAuthenticated";
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";
import { get } from "lodash";
import { getTheme } from "../../reducers/theme/selectors";
import { updateTheme } from "../../api/requests";

const { Content } = Layout;

class SettingsTheme extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      errorMessage: "",
      responseMessage: "",
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        this.setState({ isLoading: true });

        try {
          const formData = new FormData();

          if (values.logo_dark && values.logo_dark.file) {
            formData.append("logo_dark", values.logo_dark.file);
          }

          if (values.logo_light && values.logo_light.file) {
            formData.append("logo_light", values.logo_light.file);
          }

          formData.append("primary_color", values.primary_color);
          formData.append("primary_color_dark", values.primary_color_dark);
          formData.append("primary_color_light", values.primary_color_light);
          formData.append("header_color", values.header_color);
          formData.append("header_item_color", values.header_item_color);
          formData.append("header_item_highlight_color", values.header_item_highlight_color);
          formData.append("footer_color", values.footer_color);

          await updateTheme(formData);

          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
          });

          window.location.reload();
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }

          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", "Error"),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  render() {
    const { errorMessage, responseMessage, isLoading } = this.state;

    const { getFieldDecorator } = this.props.form;

    return (
      <div>
        <Layout className={classes.parentContainer}>

          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t("NamespaceSettingsTheme:Theme Settings")}
            </h3>

            <Breadcrumb>
              <Breadcrumb.Item href="/admin/settings">
                {this.props.i18n.t("Admin Settings")}
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {this.props.i18n.t("NamespaceSettingsTheme:Theme Settings")}
              </Breadcrumb.Item>
            </Breadcrumb>
            <br />

            {errorMessage && <Alert type="error" message={errorMessage} />}

            {responseMessage && (
              <Alert type="success" message={responseMessage} />
            )}

            <Card>
              <Form onSubmit={this.handleSubmit}>
                <Row gutter={12}>
                  <Col>
                    <label>
                      <b>
                        {this.props.i18n.t(
                          "NamespaceSettingsTheme:Primary Color"
                        )}
                      </b>
                      <Form.Item style={{ width: "10rem" }}>
                        {getFieldDecorator("primary_color", {
                          initialValue: get(this.props, "theme.primary_color"),
                        })(<Input type="color" />)}
                      </Form.Item>
                    </label>
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col>
                    <label>
                      <b>
                        {this.props.i18n.t(
                          "NamespaceSettingsTheme:Primary Color Dark"
                        )}
                      </b>
                      <Form.Item style={{ width: "10rem" }}>
                        {getFieldDecorator("primary_color_dark", {
                          initialValue: get(
                            this.props,
                            "theme.primary_color_dark"
                          ),
                        })(<Input type="color" />)}
                      </Form.Item>
                    </label>
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col>
                    <label>
                      <b>
                        {this.props.i18n.t(
                          "NamespaceSettingsTheme:Primary Color Light"
                        )}
                      </b>
                      <Form.Item style={{ width: "10rem" }}>
                        {getFieldDecorator("primary_color_light", {
                          initialValue: get(
                            this.props,
                            "theme.primary_color_light"
                          ),
                        })(<Input type="color" />)}
                      </Form.Item>
                    </label>
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col>
                    <label>
                      <b>
                        {this.props.i18n.t(
                          "NamespaceSettingsTheme:Header Color"
                        )}
                      </b>
                      <Form.Item style={{ width: "10rem" }}>
                        {getFieldDecorator("header_color", {
                          initialValue: get(
                            this.props,
                            "theme.header_color"
                          ),
                        })(<Input type="color" />)}
                      </Form.Item>
                    </label>
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col>
                    <label>
                      <b>
                        {this.props.i18n.t(
                          "NamespaceSettingsTheme:Header Item Color"
                        )}
                      </b>
                      <Form.Item style={{ width: "10rem" }}>
                        {getFieldDecorator("header_item_color", {
                          initialValue: get(
                            this.props,
                            "theme.header_item_color"
                          ),
                        })(<Input type="color" />)}
                      </Form.Item>
                    </label>
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col>
                    <label>
                      <b>
                        {this.props.i18n.t(
                          "NamespaceSettingsTheme:Header Item Highlight Color"
                        )}
                      </b>
                      <Form.Item style={{ width: "10rem" }}>
                        {getFieldDecorator("header_item_highlight_color", {
                          initialValue: get(
                            this.props,
                            "theme.header_item_highlight_color"
                          ),
                        })(<Input type="color" />)}
                      </Form.Item>
                    </label>
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col>
                    <label>
                      <b>
                        {this.props.i18n.t(
                          "NamespaceSettingsTheme:Footer Color"
                        )}
                      </b>
                      <Form.Item style={{ width: "10rem" }}>
                        {getFieldDecorator("footer_color", {
                          initialValue: get(
                            this.props,
                            "theme.footer_color"
                          ),
                        })(<Input type="color" />)}
                      </Form.Item>
                    </label>
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col>
                    <label>
                      <b>
                        {this.props.i18n.t(
                          "NamespaceSettingsTheme:Logo (dark)"
                        )}
                        <img
                          src={this.props.theme.logo_dark}
                          alt=""
                          style={{ height: "20px", marginLeft: "1rem" }}
                        />
                      </b>
                      <Form.Item>
                        {getFieldDecorator("logo_dark", {
                          initialValue: get(this.props, "theme.logo_dark", ""),
                        })(
                          <Upload
                            accept=".png"
                            action=""
                            beforeUpload={() => false}
                            multiple={false}
                            fileList={get(
                              this.props.form.getFieldValue("logo_dark"),
                              "fileList",
                              []
                            ).slice(-1)}
                          >
                            <Button>
                              <Icon type="upload" />
                              {!this.props.form.getFieldValue("logo_dark") &&
                              this.props.url
                                ? this.props.i18n.t("Change file")
                                : this.props.i18n.t(
                                    "NamespaceSettingsTheme:Change Logo"
                                  )}
                            </Button>
                          </Upload>
                        )}
                      </Form.Item>
                    </label>
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col>
                    <label>
                      <b>
                        {this.props.i18n.t(
                          "NamespaceSettingsTheme:Logo (light)"
                        )}
                        <img
                          src={this.props.theme.logo_light}
                          alt=""
                          style={{
                            height: "20px",
                            marginLeft: "1rem",
                            background: "#666",
                          }}
                        />
                      </b>
                      <Form.Item>
                        {getFieldDecorator("logo_light", {
                          initialValue: get(this.props, "theme.logo_light", ""),
                        })(
                          <Upload
                            accept=".png"
                            action=""
                            beforeUpload={() => false}
                            multiple={false}
                            fileList={get(
                              this.props.form.getFieldValue("logo_light"),
                              "fileList",
                              []
                            ).slice(-1)}
                          >
                            <Button>
                              <Icon type="upload" />
                              {!this.props.form.getFieldValue("logo_light") &&
                              this.props.url
                                ? this.props.i18n.t("Change file")
                                : this.props.i18n.t(
                                    "NamespaceSettingsTheme:Change Logo"
                                  )}
                            </Button>
                          </Upload>
                        )}
                      </Form.Item>
                    </label>
                  </Col>
                </Row>
                <div className={classes.actionWrapper}>
                  <Form.Item>
                    <Button
                      type="primary"
                      size="large"
                      htmlType="submit"
                      className={classes.submitButton}
                    >
                      {this.props.i18n.t("Save")}
                      {isLoading && <Icon type="loading" />}
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </Card>
          </Content>

        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  theme: getTheme(state),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "theme" })(
  isAuthenticated(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(withNamespaces()(SettingsTheme))
  )
);



// WEBPACK FOOTER //
// ./src/containers/SettingsTheme/SettingsTheme.js